import { createContext, useState } from 'react';
import api from 'services/api';

export const ProdutosContext = createContext();

export const ProdutosProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);

  const postEtiquetas = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      const res = await api.post('/Cadastros/Produto/Etiquetas', data);

      if (res?.data?.base64) {
        const byteCharacters = atob(res?.data?.base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const file = new Blob([byteArray], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }

      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const getProdutoSaldo = async ({ id, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/Cadastros/Produto/Saldo/${id}`);
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getProdutoIndicadores = async ({ id, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(
        `/Graficos/CadastrosProdutoIndicadores/${id}`
      );
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ProdutosContext.Provider
      value={{
        getLoading,
        postLoading,
        postEtiquetas,
        getProdutoSaldo,
        getProdutoIndicadores,
      }}
    >
      {children}
    </ProdutosContext.Provider>
  );
};
